module.exports = "<div class=\"cm-page-banner\" [style.backgroundImage]=\"'url(' + banner + ')'\"></div>\n"